var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossLightGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4937 0.261734C11.8354 0.610713 11.8354 1.17652 11.4937 1.5255L7.11004 5.99756L11.4937 10.4745C11.8354 10.8235 11.8354 11.3893 11.4937 11.7383C11.152 12.0872 10.598 12.0872 10.2563 11.7383L5.875 7.26377L1.49372 11.7383C1.15201 12.0872 0.59799 12.0872 0.256281 11.7383C-0.0854275 11.3893 -0.0854275 10.8235 0.256281 10.4745L4.63996 5.99756L0.256281 1.5255C-0.0854275 1.17652 -0.0854275 0.610713 0.256281 0.261734C0.59799 -0.087245 1.15201 -0.087245 1.49372 0.261734L5.875 4.73623L10.2563 0.261734C10.598 -0.087245 11.152 -0.087245 11.4937 0.261734Z",
    fill: "#BFBFBF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3937:36317",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4937 0.261734C11.8354 0.610713 11.8354 1.17652 11.4937 1.5255L7.11004 5.99756L11.4937 10.4745C11.8354 10.8235 11.8354 11.3893 11.4937 11.7383C11.152 12.0872 10.598 12.0872 10.2563 11.7383L5.875 7.26377L1.49372 11.7383C1.15201 12.0872 0.59799 12.0872 0.256281 11.7383C-0.0854275 11.3893 -0.0854275 10.8235 0.256281 10.4745L4.63996 5.99756L0.256281 1.5255C-0.0854275 1.17652 -0.0854275 0.610713 0.256281 0.261734C0.59799 -0.087245 1.15201 -0.087245 1.49372 0.261734L5.875 4.73623L10.2563 0.261734C10.598 -0.087245 11.152 -0.087245 11.4937 0.261734Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3937:36317)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossLightGrey);
export default __webpack_public_path__ + "static/media/cross-light-grey.f83db43b99dfe933cea693e64a259d7c.svg";
export { ForwardRef as ReactComponent };